import React from 'react'

const Textarea = ({ field, handleChange, formData, errors })=>  {

    return (
        <div className={field.colunms}>
            <div className="form-group">
                         <label>{field?.label} {field?.required ? <span className='astric'>*</span> : ''}</label>
                        <div className="input-bx">
                          <textarea
                            autoComplete="off"
                            name={field?.name}
                            placeholder={field.placeholder}
                            value={formData[field.name] || ""}
                            required={field.required}
                            minLength={field.minLength}
                            maxLength={field.maxLength}
                            onChange={handleChange}
                            className="form-control">
                          </textarea>
                        </div>
                        {errors[field?.name] && (
                          <div className="error">{errors[field.name]}</div>
                        )}
            </div>
        </div>
    )
}

export default Textarea;
